/**
 *  try connect to AppConnect
 */
export const connectAppConnect = () => {
  if(typeof window === `undefined`) return;
  try {
    (window as any).monapaletteConnect.getAddress().then(() => (window as any).mpurse = (window as any).monapaletteConnect).catch(() => {});
  }
  catch{ console.log("unable to connect to AppConnect") }
}